/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
  <div>
  <div class="formPosition">
      <v-card style="margin:auto;border:1px solid #006699;" width="1200" >
        <v-card-title style="background-color:#006699;color:white;"></v-card-title>
      <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>


  <!-- ***************************** show Dialogo eliminar ************************************************************** -->

        <v-row justify="center">
            <v-dialog v-model="dialogEliminar" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Eliminar Emolumento</v-card-title>
                <v-card-text>Deseja continuar com a operação ?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialogEliminar=false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="EliminarEmolumento()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

  <!-- ********************************************************************************************************** -->



    <!-- =========================== DIALOGO DE DETALHES ============================================== -->
              <template>
  <v-row justify="center">
    <v-dialog v-model="dialog_detalhes" persistent max-width="1000px">
      <v-card>
        <v-card-title style="background-color:#006699;color:white;" >
          <span class="headline">Detalhes do Produto</span>
        </v-card-title>
        <v-card-text>
          <v-container>
              <template>
                    <v-card>
                      <v-tabs
                        v-model="tab"
                        color="#006699"
                      >
                        <v-tab
                          v-for="item in tabsItems"
                          :key="item.tab"
                        >
                          {{ item.tab }}
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="tab">
                        <v-tab-item
                        >
                          <v-card flat>
                            <v-card-text>
                              <v-container>
                                <v-row style="border:1px solid #cccccc">
                                   <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Código de Barra : </span><span style="font-size:15px;font-weight:bold;">{{editedItem.codigoBarra}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Nome do Produto : </span><span style="font-size:15px;font-weight:bold;">{{editedItem.produto}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Categoria : </span><span style="font-size:15px;font-weight:bold;">{{editedItem.familia}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Descrição Reduzida : </span><span style="font-size:15px;font-weight:bold;">{{editedItem.descricaoReduzida}}</span>
                                  </v-col>
                                   <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Cadastrado em : </span><span style="font-size:15px;font-weight:bold;">{{editedItem.data_cadastro}}</span>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item
                        >
                          <v-card flat>
                            <v-card-text>
                              <v-container>
                                <v-row style="border:1px solid #cccccc">
                                  <v-col v-if="editedItem.precoVendaDefinido !== 2" cols="12" sm="6" md="12">
                                    <span  style="color:red;font-weight:bold;font-size:15px;">Preço de Venda não definido</span>
                                  </v-col>
                                   <v-col cols="12" sm="6" md="12">
                                    <span v-if="editedItem.iva === 14" style="color:#006699;font-weight:bold;font-size:15px;">Preço de Venda( IVA incluido ) : </span><span v-if="editedItem.iva === 14" style="font-size:15px;font-weight:bold;">{{ utilitarios.IntegerToMoneyValue(editedItem.precoComIva)}}</span>
                                    <span v-if="editedItem.iva !== 14" style="color:#006699;font-weight:bold;font-size:15px;">Preço de Venda: </span><span v-if="editedItem.iva !== 14" style="font-size:15px;font-weight:bold;">{{ utilitarios.IntegerToMoneyValue(editedItem.precoComIva)}}</span>
                                  </v-col>
                                  <v-col v-if="editedItem.iva === 14" cols="12" sm="6" md="12">
                                     <span v-if="editedItem.iva === 14" style="color:#006699;font-weight:bold;font-size:15px;">Preço sem Iva: </span><span v-if="editedItem.iva === 14" style="font-size:15px;font-weight:bold;">{{ utilitarios.IntegerToMoneyValue(editedItem.precoSemIva)}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">IVA: </span><span style="font-size:15px;font-weight:bold;">{{editedItem.iva}}</span>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="12">
                                    <span style="color:#006699;font-weight:bold;font-size:15px;">Descrição Reduzida : </span><span style="font-size:15px;font-weight:bold;">{{editedItem.descricaoReduzida}}</span>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item
                        >
                          <v-card flat>
                            <v-card-text>
                              <v-container>
                                <v-row style="border:1px solid #cccccc">
                                  <v-col cols="12" sm="6" md="12">
                                    <span   style="color:#006699;font-weight:bold;font-size:15px;">Controle de Stock : </span><v-icon style="font-size:20px;color:green;" v-if="editedItem.controleStock === 2">done</v-icon><v-icon style="font-size:20px;color:red;" v-if="editedItem.controleStock !== 2">clear</v-icon>
                                  </v-col>
                                   <v-col cols="12" sm="6" md="12">
                                    <span   style="color:#006699;font-weight:bold;font-size:15px;">Stock Minimo : </span><span   style="font-size:15px;font-weight:bold;">{{(editedItem.controleStock !== 2)?' ---':editedItem.stock_min}}</span>
                                  </v-col>
                                  <v-col   cols="12" sm="6" md="12">
                                     <span   style="color:#006699;font-weight:bold;font-size:15px;">Stock Máximo: </span><span   style="font-size:15px;font-weight:bold;">{{ (editedItem.controleStock !== 2)?' ---':editedItem.stock_max}}</span>
                                  </v-col>
                                  <v-col   cols="12" sm="6" md="12">
                                     <span  style="color:#006699;font-weight:bold;font-size:15px;">Stock Existente: </span><span   style="font-size:15px;font-weight:bold;">{{ editedItem.entrada_stk}}</span>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item
                        >
                          <v-card flat>
                            <v-card-text>
                              <v-container>
                                <v-row style="border:1px solid #cccccc">
                                  <v-col cols="12" sm="6" md="12">
                                    <span   style="color:#006699;font-weight:bold;font-size:15px;">Quantidade Entrada : </span><span>{{(dados_contaCorrente.length && dados_contaCorrente[0].entrada !== null)?dados_contaCorrente[0].entrada : 0}}</span>
                                  </v-col>
                                   <v-col cols="12" sm="6" md="12">
                                    <span   style="color:#006699;font-weight:bold;font-size:15px;">Quantidade Saida : </span><span   style="font-size:15px;font-weight:bold;">{{(dados_contaCorrente_saidas.length && dados_contaCorrente_saidas[0].saida !== null)?dados_contaCorrente_saidas[0].saida : 0}}</span>
                                  </v-col>
                                  <v-col   cols="12" sm="6" md="12">
                                     <span   style="color:#006699;font-weight:bold;font-size:15px;">Total de entradas(em dinheiro): </span><span   style="font-size:15px;font-weight:bold;">{{(dados_contaCorrente.length && dados_contaCorrente[0].entrada_dinheiro !== null) ? utilitarios.IntegerToMoneyValue(dados_contaCorrente[0].entrada_dinheiro) : utilitarios.IntegerToMoneyValue(0)}}</span>
                                  </v-col>
                                  <v-col   cols="12" sm="6" md="12">
                                     <span  style="color:#006699;font-weight:bold;font-size:15px;">Total de saidas(em dinheiro): </span><span   style="font-size:15px;font-weight:bold;">{{(dados_contaCorrente_saidas.length && dados_contaCorrente_saidas[0].saida_dinheiro !== null) ? utilitarios.IntegerToMoneyValue(dados_contaCorrente_saidas[0].saida_dinheiro) : utilitarios.IntegerToMoneyValue(0)}}</span>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </template>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" class="white--text"   @click="dialog_detalhes = false" col>Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </template>
    <!-- ========================================================================================================================================== -->

    <v-progress-linear
      v-if="progresso"
        indeterminate
        color="green"
        height="10"
      ></v-progress-linear>
       <v-card-title>
        <span>Emolumentos</span>
         <v-spacer></v-spacer>
         <!--  search  -->
          <div class="flex-grow-1"></div>
          <v-text-field
            v-model="searchInDb"
            label="Pesquise pelo emolumento, curso ou ano académico"
            single-line
            hide-details
          ></v-text-field>
          <v-btn small fab @click="InitializeProdutos(searchInDb)" style="color:white;" color="green">
            <v-icon>search</v-icon>
          </v-btn>
          <!-- end search  -->
      </v-card-title>
        <template>
          <v-data-table :search="search" :headers="headers" :items="produtos">
          <template v-slot:item.precoSemIva="{ item }">
              <span >{{ObterValorFormatado(item.precoSemIva)+ ' Akz'}}</span>
          </template>
          <template v-slot:item.iva="{ item }">
              <span >{{ item.iva + ' %'}}</span>
          </template>
           <template v-slot:item.precoVenda="{ item }">
              <span >{{ObterValorFormatado(item.precoVenda)+ ' kz'}}</span>
          </template>
           <template v-slot:item.precoSemIvaNoite="{ item }">
              <span >{{ObterValorFormatado(item.precoSemIvaNoite)+ ' kz'}}</span>
          </template>
           <template v-slot:item.precoSemIvaTarde="{ item }">
              <span >{{ObterValorFormatado(item.precoSemIvaTarde)+ ' kz'}}</span>
          </template>
           <template v-slot:item.unidade="{ item }">
              <span v-if="item.unidade === 1" >unidade</span>
              <span v-if="item.unidade === 2">Kg</span>
          </template>
           <template v-slot:item.status="{ item }">
             <span v-if="item.stock_min === null||item.stock_max === null">Sem controle de Stock</span>
              <v-icon v-if="(item.stock_min !== null||item.stock_max !== null)&&(item.entrada_stk <= item.stock_min)" style="color:red;" >fiber_manual_record</v-icon>
              <v-icon v-if="((item.stock_min !== null||item.stock_max !== null)&&(item.entrada_stk <= (item.stock_max/2)) && item.entrada_stk > item.stock_min ) " style="color:orange;" >fiber_manual_record</v-icon>
              <v-icon v-if="(item.stock_min !== null||item.stock_max !== null)&&(item.entrada_stk >= (item.stock_max/2))" style="color:green;" >fiber_manual_record</v-icon>
          </template>
           <template v-slot:item.action="{ item }">
                  <v-menu
                    :offset-x="offsetX"
                    :offset-y="offsetY"
                    bottom
                    origin="center center"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab dark small
                       color="#006699"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark>menu</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <!-- <v-list-item v-if="usuarioRole === 'SUPER_USER' || usuarioRole === 'ROLE_SPG' || usuarioRole === 'ROLE_RPS' "  @click="EditarPreco(item)">
                        <v-icon color="green" >edit</v-icon>Editar Preço
                      </v-list-item> -->
                      <v-list-item v-if="usuarioRole === 'SUPER_USER' || usuarioRole === 'ROLE_SPG' || usuarioRole === 'ROLE_RPS'"  @click="EditarProduto(item)">
                        <v-icon color="blue" >edit</v-icon>Editar Emolumento
                      </v-list-item>
                     <v-divider></v-divider>
                     <v-list-item @click="detalhes(item)">
                        <v-icon color="green" >view_list</v-icon>Detalhes
                      </v-list-item>
                       <!-- <v-list-item @click="movimentacoes(item)">
                        <v-icon color="green" >swap_horiz</v-icon>Movimentações
                      </v-list-item> -->
                       <v-list-item v-if="usuarioRole === 'SUPER_USER' || usuarioRole === 'ROLE_SPG' || usuarioRole === 'ROLE_RPS'" @click="ShowEliminar(item)">
                        <v-icon color="red" >delete</v-icon>Eliminar
                      </v-list-item>
                    </v-list>
                  </v-menu>
              </template>
          </v-data-table>

          <!-- DIÁLOGO EDIÇÃO DEE PREÇO DE SECTION ---------- -->

          <v-row justify="center">
            <v-dialog
              v-model="dialog"
              persistent
              max-width="600px"
            >
              <v-card>
                <v-card-title>Edição do Preço de Venda</v-card-title>
                <div class="header">
                  <div>Emolumento: <span>{{emolumentoN}}</span></div>
                  <div>Curso: <span>{{cursoN}}</span></div>
                  <div>Ano académico: <span>{{anoAcademicoN}}</span></div>
                </div>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field v-model="precoSemIva" v-money="money" @keyup="ObterPrecoDescricao()" label="Preço de Venda"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                        :disabled="true"
                          v-model="valorDescricao"
                          label="Preço por compreensão*"
                          placeholder="Preço por compreesão"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="red"
                    text
                    @click="cancelarActualizacao()"
                   >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="green darken-1"
                    text
                    @click="atualizarDados()"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>
import Swal from 'sweetalert2'
import axios from '../../plugins/axios'
import { VMoney } from 'v-money'
import utilitarios from '../../plugins/utilitarios'
const numero = require('numero-por-extenso')
const ls = require('local-storage')
export default {
  directives: { money: VMoney },
  data: () => ({
    precoComIvaInteiro: null,
    margemPreco: '',
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    motivoIsencao: '',
    disabilita_ivaPreco: false,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    descricao_isencao_ivaprecoFiltered: [],
    descricao_isencao_iva: [],
    valorDescricao: '',
    taxa_ivaPrecoSelected: null,
    taxa_iva: [],
    mostrarIva: 0,
    precoCompreensao: '',
    newIva: '',
    motivoInsercao: '',
    dialog: false,
    text: 'mensagem nao setada.',
    
    cursoN: '',
    produtos: [],
    progresso: false,
    offsetX: false,
    offsetY: true,
    overlay: false,
    searchInDb: null,
    tab: null,
    dialogEliminar: false,
    utilitarios: utilitarios,
    dialog_detalhes: false,
    objEmolumento: null,
    dados_contaCorrente: [],
    dados_contaCorrente_saidas: [],
    search: '',
    precoSemIva: '',
    headers: [
      {
        text: 'Emolumento',
        align: 'start',
        sortable: false,
        value: 'emolumento'
      },
      // { text: 'Stock Mínimo', value: 'stock_min' },
      // { text: 'Stock Máximo', value: 'stock_max' },
      { text: 'Curso', value: 'curso' },
      { text: 'Ano', value: 'classe' },
      { text: 'Manhã', value: 'precoVenda' },
      {text: 'Tarde', value: 'precoSemIvaTarde'},
      {text: 'Noite', value: 'precoSemIvaNoite'},
      { text: 'Stock Existente', value: 'entrada_stk' },
      { text: 'Ações', value: 'action' }
    ],
    tabsItems:
    [
      { id: 1, tab: 'Geral' },
      { id: 2, tab: 'Preços' },
      { id: 3, tab: 'Estoque' },
      { id: 3, tab: 'Conta Corrente do Produto' }
    ],
    editedItem:
     {
       armazem: '',
       codigoBarra: '',
       descricaoPreco: '',
       descricaoReduzida: '',
       entrada_stk: 0,
       especificacaoProduto: '',
       familia: '',
       isencao: '',
       iva: 0,
       margem: 0,
       mercadoria: '',
       pkArmazem: 0,
       pkFamilia: 0,
       pkProduto: 0,
       precoComIva: 0,
       precoSemIva: 0,
       produto: '',
       stock_max: null,
       stock_min: null,
       tipoProduto: 0,
       unidade: 0,
       controleStock: 0,
       precoVendaDefinido: 0,
       calculoPrecoVenda: 0
     }
  }),

  computed: {
    usuarioRole () {
       return ls.get('role')
    },

    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    },

    regime_id () {
       return ls.get('regime')
    },

    regime (){
      return ls.get('regime_descricao')
    },

    id_negocio (){
      return ls.get('id_negocio')
    },
    negocio () {
      return ls.get('negocio')
    },
    isEscola () {
     return  this.negocio === 'Escola'
    }
  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    },

    tab (val) {
      console.log(val)
    }
  },

  created () {
    this.InitializeProdutos()
    this.initializeIsencaoIva()
    this.initializeTaxaIva()
  },

  methods: {
    async initializeIsencaoIva () {
      try {
        this.descricao_isencao_iva = await axios
          .get('/IsencaoIvaFindall')
          .then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, 
    async initializeTaxaIva () {
      try {
        this.taxa_iva = await axios
          .get('/TaxaIvaFindall')
          .then(res => res.data)
          
      } catch (error) {

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    SelecionaIvaPreco () {
      if (this.taxa_ivaPrecoSelected !== null) {
        if (this.taxa_ivaPrecoSelected === 0) {
          this.descricao_isencao_ivaprecoFiltered = this.descricao_isencao_iva
          this.disabilita_ivaPreco = false
        } else {
          this.disabilita_ivaPreco = true
          this.descricao_isencao_ivaprecoFiltered = []
        }
        this.CalculaPreComIva(this.taxa_ivaPrecoSelected / 100)
        let iva = utilitarios.ObterValorDaPercentagem(utilitarios.MoneyValueToInteger(this.precoSemIva),this.taxa_ivaPrecoSelected)
        this.valorIva  = iva
      }
    },

    cancelarActualizacao() {
      this.precoSemIva = ''
      this.valorDescricao = ''
      this.taxa_ivaPrecoSelected = null
      this.motivoIsencao = ''
      this.dialog = false
    },
    
   async atualizarDados() {
  
    let produto = this.$store.state.produto;
    let params = {
      precoSemIva: utilitarios.MoneyValueToInteger(this.precoSemIva),
      descricaoPreco: this.valorDescricao,
      produto: produto.pkProduto
    }

  
    // validação dos campos

    if (!this.precoSemIva || !this.valorDescricao ) {
      Swal.fire ('Informação','Existem campos vazios','warning')
    } else {

      try {
        let msg = await axios.post('/atualizarPrecos', params).then(res => res.data)
          if (msg.affectedRows !== undefined) {
            if (msg.affectedRows >= 0) {
              Swal.fire('Informação','Preço actualizado com sucesso','success')
              this.precoSemIva = ''
              this.precoCompreensao = ''
              this.newIva = ''
              this.motivoInsercao = ''
              this.dialog = false
              this.InitializeProdutos()
            } else {
              Swal.fire('Ocorreu um erro ao tentar registrar o Produto!','','warning')
            }
          } else if (msg.sqlMessage !== undefined) {
            Swal.fire('Ocorreu um erro ao tentar registrar o Produto!','','warning')
          }
      } catch (error) {
        Swal.fire('Ocorreu um erro ao tentar registrar o Produto!','','warning')
      }
    }
  },

    ObterPrecoDescricao () {
      let result = utilitarios.MoneyValueToInteger(this.precoSemIva)
      if( result <= 0 ){
          this.valorDescricao = ''
          this.precoComIva  = ''
      }else{
        let valor = numero.porExtenso(result)
        valor = (valor.includes('um mil')) ? valor.replace('um mil', 'mil') : valor
        this.valorDescricao = valor + ' Kwanza(s)'
        if( this.regime_id !== 1 ){
         this.CalculaPreComIva(this.taxa_ivaPrecoSelected / 100)
         let iva = utilitarios.ObterValorDaPercentagem(utilitarios.MoneyValueToInteger(this.precoSemIva),this.taxa_ivaPrecoSelected)
         this.valorIva  = iva
        }
      }
    },

    LimpaCamposPreco () {
      this.precoComIva = ''
      this.precoComIvaInteiro = ''
      this.precoSemIvaMargem = ''
      this.precoSemIva = ''
      this.valorDescricao = ''
      this.margemPrecoAutomatico = ''
      this.margemPreco = ''
      this.motivoIsencao = ''
      this.taxa_ivaPrecoSelected = ''
      this.margem = ''
    },

    SelecionaEspecProduto () {
      if (this.especificacaoProdutoSelected.id === 0) {
        this.precoComIvaInteiro = 0
        this.precoSemIva = 0
        this.margemPreco = 0
        this.taxa_ivaPrecoSelected = 0
        this.valorDescricao = 'Zero Kwanza'
      }
    },

    SelecionaEspecProduto () {
      if (this.especificacaoProdutoSelected.id === 0) {
        this.precoComIvaInteiro = 0
        this.precoSemIva = 0
        this.margemPreco = 0
        this.taxa_ivaPrecoSelected = 0
        this.valorDescricao = 'Zero Kwanza'
      }
    },

    savePreco () {
      if (this.$refs.form.validate()) {
        let params =
          {
            descricaoPreco: this.valorDescricao,
            margem: this.margemPreco,
            precoSemIva: this.precoSemIva,
            iva: this.taxa_ivaPrecoSelected,
            motivoIsencao: this.motivoIsencao,
            predifinido: this.predifinido,
            precoComIva: this.precoComIva
          }

        this.tabelas_preco.push(params)
        this.dialog = false
      }
    },

    async saveProduto () {
      if (this.$refs.form1.validate() && this.$refs.form.validate() && this.$refs.form2.validate()) {
        // Definição das variaveis
        this.overlay = true
        let precoVenda = (this.Precoautomatico) ? this.precoSemIvaMargem : this.precoSemIva

        let params =
        {
          descricao: this.descricaoProduto,
          descricaoReduzida: this.descricaoReduzida,
          codigoBarra: this.codigoBarraSelected,
          armazem: this.armazemSelected,
          tipoProduto: this.tipoProdutoSelected,
          mercadoria: this.mercadoriaSelected,
          familia: (this.isEscola)?null:((this.familiaSelected.pkFamiliaProduto !== undefined) ? this.familiaSelected.pkFamiliaProduto : this.familiaSelected),
          precoComIva: this.precoComIvaInteiro,
          precoSemIva: (this.DefinirPrecoVendaSelected === 1) ? null : ((precoVenda !== 0) ? utilitarios.MoneyValueToInteger(precoVenda) : 0),
          margem: (this.Precoautomatico) ? this.margemPrecoAutomatico : this.margemPreco,
          iva: this.taxa_ivaPrecoSelected,
          isencao: this.motivoIsencao,
          descricaoPreco: this.valorDescricao,
          pkProduto: 0,
          especificacaoProduto: this.especificacaoProdutoSelected,
          stockMinimo: (this.controleStockSelected === 1) ? null : this.stockMinimo,
          stockMaximo: (this.controleStockSelected === 1) ? null : this.stockMaximo,
          unidade: this.unidadeSelecionada,
          controleStock: this.controleStockSelected,
          precoVendaDefinido: this.DefinirPrecoVendaSelected,
          CalculoPrecoVenda: this.tipoPrecoSelecionada,
          substituto: (this.produtoSubstitutoModel.length) ? this.produtoSubstitutoModel : '',
          curso: this.cursoSelected,
          classe: this.classeSelected,
          classes: this.classesFiltered
        }
        try {
          //   let  payload =""
          this.isLoading = true
          let msg = await axios
            .post('/produtoAdd', params)
            .then(res => res.data)
          if (msg.affectedRows !== undefined) {
            if (msg.affectedRows >= 1) {
               Swal.fire((this.negocio === 'Escola')?'Emolumento registrado com sucesso':'Produto registrado com sucesso','','success')
              this.tab = 0
              this.overlay = false
              this.reset()
            } else {
              Swal.fire('Ocorreu um erro ao tentar registrar o Produto!','','warning')
              this.tab = 0
            }
          } else if (msg.sqlMessage !== undefined) {
            Swal.fire('Ocorreu um erro ao tentar registrar o Produto!','','warning')
            this.tab = 0
          }
        } catch (error) {
          this.isLoading = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        } finally {
          this.overlay = false
        }
      }
    },

    LimpaCamposPreco () {
      this.precoComIva = ''
      this.precoComIvaInteiro = ''
      this.precoSemIvaMargem = ''
      this.precoSemIva = ''
      this.valorDescricao = ''
      this.margemPrecoAutomatico = ''
      this.margemPreco = ''
      this.motivoIsencao = ''
      this.taxa_ivaPrecoSelected = ''
      this.margem = ''
    },

    CalculaPreComIva (valor) {
      let Preco = (!this.disableMargem) ? this.precoSemIvaMargem : this.precoSemIva
      let valorIva = ((Preco === 0) ? 0 : utilitarios.MoneyValueToInteger(Preco)) * valor
      let valorFinal = ((Preco === 0) ? 0 : utilitarios.MoneyValueToInteger(Preco)) + valorIva
      this.precoComIva = valorFinal
      this.precoComIva = this.ObterValorFormatado(valorFinal)
      this.precoComIvaInteiro = valorFinal
    },

    async ShowEliminar (item){
      this.objEmolumento = item
      try {
        this.overlay = true
        let result  = await this.verificarPagamentoEmolumento(item).then((res)=>res.data)
        this.overlay = false
        if(result.length){
            Swal.fire('Informação','<p>Não é possível eliminar o emolumento<br>Já tem pagamento associado.</p>','warning')
        }else{
           this.dialogEliminar = true
        }
      } catch (error) {
        Swal.fire('Informação','<p>Ocorreu um erro ao tentar efectuar a operação.</p>','error')
        this.overlay = false
      }
    },

    async  InitializeProdutos () {

         if (!this.searchInDb) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + this.searchInDb + '"}'
        }

      try {
        this.progresso = true;
        this.produtos = await axios.get('/produtosFindall-escola/'+payload).then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
        this.progresso = false
      }
    },
    async  CarregaDadosConta (fkProduto) {
      try {
        //   let  payload =""
        this.overlay = true
        this.dados_contaCorrente = await axios
          .get('/ContaCorrente-entradas/' + fkProduto)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async  CarregaDadosConta_saidas (fkProduto) {
      try {
        //   let  payload =""
        this.overlay = true
        this.dados_contaCorrente_saidas = await axios
          .get('/ContaCorrente-saidas/' + fkProduto)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    movimentacoes (item) {
      this.$store.state.produtoDetalhe = item
      this.$router.push('detalhes-movimentacao')
    },
    
    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      return formated.toString().replace('AOA', '')
    },

    EditarPreco(item) {
      this.emolumentoN = item.emolumento 
      this.cursoN = item.curso
      this.anoAcademicoN = item.classe
      this.$store.state.produto = item
      this.precoSemIva = this.ObterValorFormatado(item.precoSemIva)
      this.dialog = true;
    },

    EditarProduto (item) {
      this.$store.state.produto = item
      this.$router.push('/editar-emolumento')
    },

    async verificarPagamentoEmolumento (item) {
      try {
        return  await   axios.post('verificaEmolumentoTemPagamento',item)
      } catch (error) {
         Swal.fire('Informação','<p>Ocorreu um erro ao tentar efectuar a operação.</p>','error')
      }
    },  

    async EliminarEmolumento(){
        try {
          this.overlay = true
         let result = await  axios.post('eliminarEmolumento',this.objEmolumento).then((res)=>res.data)
         this.overlay = false
         if( result.affectedRows >= 1 ){
            let index = this.produtos.indexOf(this.objEmolumento)
            this.produtos.splice(index,1)
            Swal.fire('Informação','<p>Emolumento eliminado com sucesso.</p>','success')
            this.dialogEliminar = false
         }
        } catch (error) {
          this.overlay = false
           Swal.fire('Informação','<p>Ocorreu um erro ao tentar efectuar a operação.</p>','error')
        }
    },

    detalhes (item) {
      this.editedItem = Object.assign(this.editedItem, item)
      this.CarregaDadosConta(this.editedItem.pkProduto).then(() => {
        this.CarregaDadosConta_saidas(this.editedItem.pkProduto).then(() => {
          this.dialog_detalhes = true
        })
      })
    }

  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}

.header {
  width: 90%;
  margin: auto;
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.header div {
  color: #1d1de6;
}

.header div span {
  color: grey;
}
.cancel-button {
  background-color: #ee3939;
  font-weight: bold;
}
</style>
